import { buildVars } from '@/constants/buildVars.js';
import { createCommonFlowResolvers } from './base/createCommonFlowResolvers.js';
import { runFlow } from './base/runFlow.js';

export async function runOneSpecificCinematicFlow() {
  const flowKeys = buildVars.flow_directLinkToSingleCinematic!;
  const flowResolvers = createCommonFlowResolvers();
  await runFlow(flowKeys, flowResolvers);
}
